/* eslint-disable import/no-cycle */
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import account from './account'
import admin from './admin'
// Modules
import app from './app'
import appConfig from './app-config'
import auth from './auth'
import batch from './batch'
import dashboard from './dashboard'
import operations from './operations'
import posting from './posting'
import reports from './reports'
import verticalMenu from './vertical-menu'
import eChannels from './echannels'
import fraudmonitor from './fraudmonitor'
import llms from './llms'

Vue.use(Vuex)

const vuexPersistence = new VuexPersistence({
  storage: window.localStorage,
})

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    account,
    verticalMenu,
    posting,
    reports,
    operations,
    admin,
    auth,
    batch,
    dashboard,
    eChannels,
    fraudmonitor,
    llms,
  },
  plugins: [vuexPersistence.plugin],
  strict: process.env.DEV,
})
